import Vue from 'vue'
import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'publishing/sheets'
const DEFAULT_SHEET = {
    "id"                        : 0,
    "alvId"                     : "ALV000000000PS",
    "title"                     : null,
    "sheetNumber"               : null,
    "firstBroadcastDate"        : null,
    "productionYear"            : null,
    "productionCountry"         : null,
    "note"                      : null,
    "tag"                       : null,
    "type"                      : "film/tv",
    "avType"                    : null,
    "avFirstExploitation"       : null,
    "avMessageType"             : null,
    "completenessCuesheetYesNo" : null,
    "commissionedWorkYesNo"     : null,
    "commissioningChannel"      : null,
    "producer"                  : null,
    "producerEmail"             : null,
    // "path"                  : null,
    "works"                     : [],
    "versionTypes"              : [],
    "regions"                   : 1,
    "releaseType"               : null,
    "platform"                  : null,
    "provider"                  : null,
    "url"                       : null,
    'synchronizationRights'     : null,
    // SETLIST
    "status"                    : null,
    "setDate"                   : null,
    "setStartTime"              : null,
    "setEndTime"                : null,
    "setType"                   : null,
    "eventName"                 : null,
    "eventType"                 : null,
    "eventVenue"                : null,
    "eventVenueId"              : null,
    "eventVenueSpace"           : null,
    "eventVenueType"            : null,
    "eventOrganizer"            : null,
    "eventOrganizerId"          : null,
    "eventOrganizerYesNo"       : null,
    "eventBandleader"           : null,
    "eventPerformer"            : null,
    "eventHighestTicketPrice"   : null,
    "eventNumberOfConcertgoers" : null,
    "eventNumberOfMusicians"    : null,
}

const DEFAULT_PDF = {
    "fileId"    : null,
    "path"      : null
}

const DEFAULT_WORK = {
        "id" : 0,
        "workAvType": null,
        "workCharacteristicType": null,
        "workSheetSeconds": null,
        "workSetlistType": null,
        "workSetlistSeconds": null,
        "bigRight": null
}
const state = {
// List
    sheets: [],
    selectedSheets: [],
    isAllSelectedSheets: false,
    expandedSheets: [],
    sheetsDetailsSelectedCompany:[],

// Filters
    sheetsSearch: '',
    selectedSheetsTypeFilter:null,
    selectedSheetsYearsFilter:null,

// Actions (Buttons, Import, Export)
    selectedSheetsAction: [],

    // Av Report
    showAvReportDialog: false,
    avReportDialogText: '',
    
    //Export
    exportSheetsDetailsType: [],

    //Gema AV (JSON)
    showGemaAvRegistrationDialog: false,
    gemaAvRegistrationDialogText: 'lang_PUBLISHING_SHEETS_AV_REGISTRATION_DIALOG_TEXT_DEFAULT',
    gemaAvRegistrationDialogReportLink: null,
    gemaAvRegistrationDialogAllowSend: false,

//Actions dialogs
    showExportSheetsDialog:false,

// Details (Edit Form + Read Only)  
    defaultNewSheet: DEFAULT_SHEET,    
    sheetDetails: {},
    sheetUniqueId: '',    
    // Edit Form Fields  
    sheetVersionTypeOptions: [],
    sheetRegionsOptions: [],
    sheetCarrierTypeOptions: [],   
    // Setlist autocomplete
    sheetEventVenueOptions: [],
    sheetEventOrganizerOptions: [],
    sheetEventBandleaderOptions: [],
    sheetEventPerformerOptions: [],
    // Venue Dialog
    selectedVenueForSheets: [],
    venueForSheetsSearch: '',
    showConnectVenueToSheetDialog: false,
    totalListedConnectVenueToSheetDialog: 0,
    totalRecordsConnectVenueToSheetDialog: 0,
    
    // Works Panel
    // sheetsActivePanels: [0,1],
    defaultSheetsWorks:DEFAULT_WORK,
    sheetsWorks: [],    
    sheetWorkSearch: '',
    selectedSheetWork: [],
    totalSheetWorkListed: null,
    totalSheetWorkRecords: null,
    sheetWorksAvTypesOptions: [],  
    sheetWorksCharacteristicOptions: [],    
    // Adding Dialog
    showConnectWorksToSheetDialog: false,
    sheetWorkInterpretOptions: [],
    sheetWorkDialogDetails: {
        title: null,
        interpret: null,
        duration: null,
        tags: null
    },
    // Editing Dialog
    sheetsWorksEditingDialogDetails: {},
    selectedSheetsWorks: [],

    // PDF Panel
    sheetsPdf: DEFAULT_PDF,
    showUploadPDFDialog: false,
    uploadPDFDialogText: '',
    uploadedPDFFileId: null,  
}

const getters = {
    // List    
    getSheets(state)                                        { return state.sheets },
    getSelectedSheets(state)                                { return state.selectedSheets },
    getIsAllSelectedSheets(state)                           { return state.isAllSelectedSheets },
    getExpandedSheets(state)                                { return state.expandedSheets },
    getSheetsDetailsSelectedCompany(state)                  { return state.sheetsDetailsSelectedCompany },

    // Filters
    getSheetsSearch(state)                                  { return state.sheetsSearch },
    getSelectedSheetsTypeFilter(state)                      { return state.selectedSheetsTypeFilter },
    getSelectedSheetsYearsFilter(state)                     { return state.selectedSheetsYearsFilter },


    // Actions (Buttons, Import, Export)
    getSelectedSheetsAction(state)                          { return state.selectedSheetsAction },

    // Av Report
    getShowAvReportDialog(state)                    { return state.showAvReportDialog },
    getAvReportDialogText(state)                    { return state.avReportDialogText },

    //GEMA AV(JSON)
    getShowGemaAvRegistrationDialog(state)          { return state.showGemaAvRegistrationDialog },
    getGemaAvRegistrationDialogText(state)          { return state.gemaAvRegistrationDialogText },
    getGemaAvRegistrationDialogReportLink(state)    { return state.gemaAvRegistrationDialogReportLink },
    getGemaAvRegistrationDialogAllowSend(state)     { return state.gemaAvRegistrationDialogAllowSend },

    // Details (Edit Form + Read Only)
    getDefaultNewSheet(state)                       { return state.defaultNewSheet },
    getSheetsDetails(state)                         { return state.sheetDetails },
    getSheetsUniqueId(state)                        { return state.sheetUniqueId },

    //Export
    getExportSheetsDetailsType(state) { return state.exportSheetsDetailsType },
    // Actions Dialogs
    getShowExportSheetsDialog(state) { return state.showExportSheetsDialog },

    // Details (Edit Form + Read Only)
    getDefaultNewSheet(state) { return state.defaultNewSheet },
    getSheetsDetails(state) { return state.sheetDetails },
    getSheetsUniqueId(state) { return state.sheetUniqueId },
    // Edit Form Fields 
    getSheetVersionTypeOptions(state)               { return state.sheetVersionTypeOptions },
    getSheetRegionsOptions(state)                   { return state.sheetRegionsOptions },
    getSheetCarrierTypeOptions(state)               { return state.sheetCarrierTypeOptions },

    // Generic fields
    getSheetDetailsAlvId(state)                     { return state.sheetDetails.alvId },
    getSheetDetailsTitle(state)                     { return state.sheetDetails.title },
    getSheetDetailsType(state)                      { return state.sheetDetails.type },
    getSheetDetailsTag(state)                       { return state.sheetDetails.tag },  
    getSheetDetailsNote(state)                      { return state.sheetDetails.note },

    // FILM/TV fields
    getSheetDetailsSheetNumber(state)               { return state.sheetDetails.sheetNumber },
    getSheetDetailsFirstBroadcastDate(state)        { return state.sheetDetails.firstBroadcastDate },
    getSheetDetailsProductionYear(state)            { return state.sheetDetails.productionYear },
    getSheetDetailsProductionCountry(state)         { return state.sheetDetails.productionCountry },
    getSheetDetailsFileId(state)                    { return state.sheetDetails.fileId },
    getSheetDetailsVersionType(state)               { return state.sheetDetails.versionTypes },
    getSheetDetailsRegions(state)                   { return state.sheetDetails.regions },
    getSheetDetailsCarrierType(state)               { return state.sheetDetails.releaseType },
    getSheetDetailsPlatform(state)                  { return state.sheetDetails.platform },
    getSheetDetailsProvider(state)                  { return state.sheetDetails.provider },
    getSheetDetailsUrl(state)                       { return state.sheetDetails.url },
    getSheetDetailsInternet(state)                  { return state.sheetDetails.internetValue },
    getSheetDetailsAvType(state)                    { return state.sheetDetails.avType },
    getSheetDetailsAvFirstExploitation(state)       { return state.sheetDetails.avFirstExploitation },
    getSheetDetailsAvMessageType(state)             { return state.sheetDetails.avMessageType },
    getSheetDetailsCompletenessCuesheetYesNo(state) { return state.sheetDetails.completenessCuesheetYesNo },
    getSheetDetailsCommissionedWorkYesNo(state)     { return state.sheetDetails.commissionedWorkYesNo },
    getSheetDetailsCommissioningChannel(state)      { return state.sheetDetails.commissioningChannel },
    getSheetDetailsProducer(state)                  { return state.sheetDetails.producer },
    getSheetDetailsProducerEmail(state)             { return state.sheetDetails.producerEmail },
    getSheetDetailsSynchronizationRights(state)     { return state.sheetDetails.synchronizationRights },
    // SETLIST fields
    getSheetDetailsSetDate(state)                   { return state.sheetDetails.setDate },    
    getSheetDetailsSetStartTime(state)              { return state.sheetDetails.setStartTime },    
    getSheetDetailsSetEndTime(state)                { return state.sheetDetails.setEndTime },    
    getSheetDetailsSetType(state)                   { return state.sheetDetails.setType },    
    getSheetDetailsEventName(state)                 { return state.sheetDetails.eventName },    
    getSheetDetailsEventType(state)                 { return state.sheetDetails.eventType },    
    getSheetDetailsEventVenue(state)                { return state.sheetDetails.eventVenue },    
    getSheetDetailsEventVenueId(state)              { return state.sheetDetails.eventVenueId },
    getSheetDetailsEventVenueSpace(state)           { return state.sheetDetails.eventVenueSpace },    
    getSheetDetailsEventVenueType(state)            { return state.sheetDetails.eventVenueType },    
    getSheetDetailsEventOrganizer(state)            { return state.sheetDetails.eventOrganizer },    
    getSheetDetailsEventOrganizerId(state)          { return state.sheetDetails.eventOrganizerId },    
    getSheetDetailsEventOrganizerYesNo(state)       { return state.sheetDetails.eventOrganizerYesNo },    
    getSheetDetailsStatus(state)                    { return state.sheetDetails.status },    
    getSheetDetailsEventBandleader(state)           { return state.sheetDetails.eventBandleader },    
    getSheetDetailsEventPerformer(state)            { return state.sheetDetails.eventPerformer },    
    getSheetDetailsEventHighestTicketPrice(state)   { return state.sheetDetails.eventHighestTicketPrice },    
    getSheetDetailsEventNumberOfConcertgoers(state) { return state.sheetDetails.eventNumberOfConcertgoers },    
    getSheetDetailsEventNumberOfMusicians(state)    { return state.sheetDetails.eventNumberOfMusicians },   
    // SETLIST autocompletes
    getSheetEventVenueOptions(state)                { return state.sheetEventVenueOptions },
    getSheetEventOrganizerOptions(state)            { return state.sheetEventOrganizerOptions },
    getSheetEventBandleaderOptions(state)           { return state.sheetEventBandleaderOptions },
    getSheetEventPerformerOptions(state)            { return state.sheetEventPerformerOptions },
    // Venue Dialog
    getSelectedVenueForSheets(state)                { return state.selectedVenueForSheets },
    getVenueForSheetsSearch(state)                  { return state.venueForSheetsSearch },
    getShowConnectVenueToSheetDialog(state)         { return state.showConnectVenueToSheetDialog },
    getTotalListedConnectVenueToSheetDialog(state)  { return state.totalListedConnectVenueToSheetDialog },
    getTotalRecordsConnectVenueToSheetDialog(state) { return state.totalRecordsConnectVenueToSheetDialog },

    // Works Panel
    // getSheetsActivePanels(state) { return state.sheetsActivePanels },
    getDefaultSheetsWorks(state)                    { return state.defaultSheetsWorks},
    getSheetsWorks(state)                           { return state.sheetsWorks },
    getSheetWorkSearch(state)                       { return state.sheetWorkSearch },
    getSelectedSheetWork(state)                     { return state.selectedSheetWork },
    getTotalSheetWorkListed(state)                  { return state.totalSheetWorkListed },
    getTotalSheetWorkRecords(state)                 { return state.totalSheetWorkRecords },
    getSheetWorksAvTypesOptions(state)              { return state.sheetWorksAvTypesOptions },
    getSheetWorksCharacteristicOptions(state)       { return state.sheetWorksCharacteristicOptions },
    // Add Dialog
    getShowConnectWorksToSheetDialog(state)         { return state.showConnectWorksToSheetDialog },
    getSheetWorkInterpretOptions(state)             { return state.sheetWorkInterpretOptions },
    getSheetWorkDialogDetails(state)                { return state.sheetWorkDialogDetails },
    getSheetWorkDetailsInterpret(state)             { return state.sheetWorkDialogDetails.interpret },
    getSheetWorkDetailsWorkTitle(state)             { return state.sheetWorkDialogDetails.title },
    getSheetWorkDetailsDuration(state)              { return state.sheetWorkDialogDetails.duration },
    getSheetWorkDetailsTags(state)                  { return state.sheetWorkDialogDetails.tags },

    // Editing Dialog
    getSheetsWorksEditingDialogDetails(state)       { return state.sheetsWorksEditingDialogDetails },
    getSelectedSheetsWorks(state)                   { return state.selectedSheetsWorks },
    getSheetsWorksDetailsWorkAvType(state)          { return state.sheetsWorksEditingDialogDetails.workAvType },
    getSheetsWorksDetailsWorkCharacteristicType(state) { return state.sheetsWorksEditingDialogDetails.workCharacteristicType },
    getSheetsWorksDetailsWorkSheetSeconds(state)    { return state.sheetsWorksEditingDialogDetails.workSheetSeconds },
    getSheetsWorksDetailsWorkSetlistSeconds(state)  { return state.sheetsWorksEditingDialogDetails.workSetlistSeconds },
    getSheetsWorksDetailsWorkSetlistType(state)     { return state.sheetsWorksEditingDialogDetails.workSetlistType },
    getSheetsWorksDetailsBigRight(state)            { return state.sheetsWorksEditingDialogDetails.bigRight },

    // PDF Panel
    getDefaultSheetsPdf()                           { return DEFAULT_PDF },
    getSheetsPdf(state)                             { return state.sheetsPdf },
    getSheetsPdfFileId(state)                       { return state.sheetsPdf.fileId },
    getSheetsPdfPath(state)                         { return state.sheetsPdf.path },
    getShowUploadPDFDialog(state)                   { return state.showUploadPDFDialog },
    getUploadPDFDialogText(state)                   { return state.uploadPDFDialogText },
    getUploadedPDFFileId(state)                     { return state.uploadedPDFFileId },    
}

const mutations = {
// List
    setSheets: (state, sheets)                              => { state.sheets = sheets },
    setSelectedSheets: (state, selected)                    => { state.selectedSheets = selected },
    setIsAllSelectedSheets: (state, isSelected)             => { state.isAllSelectedSheets = isSelected },
    setExpandedSheets: (state, sheet) => { 
        if(Object.keys(sheet).length === 0) state.expandedSheets = []
        else state.expandedSheets.push(sheet) 
    },
    setSheetsDetailsSelectedCompany:                        (state, value) => { state.sheetsDetailsSelectedCompany = value },

// Filters
    setSheetsSearch: (state, search)                        => { state.sheetsSearch = search },
    setSelectedSheetsTypeFilter: (state, option)            => { state.selectedSheetsTypeFilter = option },
    setSelectedSheetsYearsFilter: (state, option)           => { state.selectedSheetsYearsFilter = option },
// Actions (Buttons, Import, Export)
    setSelectedSheetsAction: (state, action)                => { state.selectedSheetsAction = action },

    // Av Report
    setShowAvReportDialog: (state, show)                    => { state.showAvReportDialog = show },
    setAvReportDialogText: (state, text)                    => { state.avReportDialogText = text },

    //Export
    setExportSheetsDetailsType: (state, type) => { state.exportSheetsDetailsType = type },

    //GEMA AV(JSON)
    setShowGemaAvRegistrationDialog: (state,  value)        => { state.showGemaAvRegistrationDialog = value },
    setGemaAvRegistrationDialogText:(state, value)          => { state.gemaAvRegistrationDialogText = value },
    setGemaAvRegistrationDialogReportLink:(state, value)    => { state.gemaAvRegistrationDialogReportLink = value },
    setGemaAvRegistrationDialogAllowSend:(state, value)     => { state.gemaAvRegistrationDialogAllowSend = value },

// Actions Dialogs 
    setShowExportSheetsDialog: (state, show) => { state.showExportSheetsDialog = show },


// Details (Edit Form + Read Only)  
    setDefaultNewSheet: (state)                             => { state.defaultNewSheet = DEFAULT_SHEET },
    setSheetsDetails: (state, details)                      => { state.sheetDetails = details },
    setSheetsUniqueId: (state, uniqueId)                    => { state.sheetUniqueId = uniqueId },
    // Edit Form Fields
    setSheetVersionTypeOptions: (state, options)            => { state.sheetVersionTypeOptions = options },
    setSheetRegionsOptions: (state, options)                => { state.sheetRegionsOptions = options },
    setSheetCarrierTypeOptions: (state, options)            => { state.sheetCarrierTypeOptions = options}, 
    
    setSheetDetailsAlvId: (state, alvId)                    => { state.sheetDetails.alvId = alvId },
    setSheetDetailsTitle: (state, title)                    => { state.sheetDetails.title = title },
    setSheetDetailsSheetNumber: (state, number)             => { state.sheetDetails.sheetNumber = number },
    setSheetDetailsFirstBroadcastDate: (state, date)        => { state.sheetDetails.firstBroadcastDate = date },
    setSheetDetailsProductionYear: (state, year)            => { state.sheetDetails.productionYear = year },
    setSheetDetailsProductionCountry: (state, country)      => { state.sheetDetails.productionCountry = country },
    setSheetDetailsNote: (state, note)                      => { state.sheetDetails.note = note },
    setSheetDetailsTag: (state, tag)                        => { state.sheetDetails.tag = tag }, 
    setSheetDetailsType: (state, value)                     => { state.sheetDetails.type = value },    
    setSheetDetailsAvType: (state, value)                   => { state.sheetDetails.avType = value }, 
    setSheetDetailsAvFirstExploitation: (state, value)      => { state.sheetDetails.avFirstExploitation = value },  
    setSheetDetailsAvMessageType: (state, value)            => { state.sheetDetails.avMessageType = value },
    setSheetDetailsCompletenessCuesheetYesNo: (state, value) => { state.sheetDetails.completenessCuesheetYesNo = value},
    setSheetDetailsCommissionedWorkYesNo:(state, value)     => { state.sheetDetails.commissionedWorkYesNo = value },
    setSheetDetailsCommissioningChannel:(state,value)       => { state.sheetDetails.commissioningChannel = value },
    // setSheetDetailsPdfPath: (state, path) => { state.sheetDetails.path = path },
    setSheetDetailsFileId: (state, id)                      => { state.sheetDetails.fileId = id },
    setSheetDetailsVersionType: (state, value )             => { state.sheetDetails.versionTypes = value },
    setSheetDetailsRegions: (state, regions)                => { state.sheetDetails.regions = regions },
    setSheetDetailsCarrierType: (state, type)               => { state.sheetDetails.releaseType = type },
    setSheetDetailsPlatform: (state, platform)              => { state.sheetDetails.platform = platform },
    setSheetDetailsProvider: (state, provider)              => { state.sheetDetails.provider = provider },
    setSheetDetailsUrl: (state, url)                        => { state.sheetDetails.url = url },
    setSheetDetailsInternet: (url, selected)                => { state.sheetDetails.internetValue = selected },
    setSheetDetailsProducer:(state, value)                  => { state.sheetDetails.producer = value },    
    setSheetDetailsProducerEmail:(state, value)             => { state.sheetDetails.producerEmail = value }, 
    setSheetDetailsSynchronizationRights:(state, value)     => { state.sheetDetails.synchronizationRights = value },    
    // SETLIST
    setSheetDetailsSetDate: (state, value)                  => { state.sheetDetails.setDate = value },    
    setSheetDetailsSetStartTime: (state, value)             => { state.sheetDetails.setStartTime = value },    
    setSheetDetailsSetEndTime: (state, value)               => { state.sheetDetails.setEndTime = value },    
    setSheetDetailsSetType: (state, value)                  => { state.sheetDetails.setType = value },    
    setSheetDetailsEventName: (state, value)                => { state.sheetDetails.eventName = value },    
    setSheetDetailsEventType: (state, value)                => { state.sheetDetails.eventType = value },    
    setSheetDetailsEventVenue: (state, value)               => { state.sheetDetails.eventVenue = value },    
    setSheetDetailsEventVenueId: (state, id)                => { state.sheetDetails.eventVenueId = id },
    setSheetDetailsEventVenueSpace: (state, value)          => { state.sheetDetails.eventVenueSpace = value },    
    setSheetDetailsEventVenueType: (state, value)           => { state.sheetDetails.eventVenueType = value },    
    setSheetDetailsEventOrganizer: (state, value)           => { state.sheetDetails.eventOrganizer = value },    
    setSheetDetailsEventOrganizerId: (state, value)         => { state.sheetDetails.eventOrganizerId = value },    
    setSheetDetailsEventOrganizerYesNo: (state, value)      => { state.sheetDetails.eventOrganizerYesNo = value },    
    setSheetDetailsStatus: (state, value)                   => { state.sheetDetails.status = value },    
    setSheetDetailsEventBandleader: (state, value)          => { state.sheetDetails.eventBandleader = value },    
    setSheetDetailsEventPerformer: (state, value)           => { state.sheetDetails.eventPerformer = value },    
    setSheetDetailsEventHighestTicketPrice: (state, value)  => { state.sheetDetails.eventHighestTicketPrice = value },    
    setSheetDetailsEventNumberOfConcertgoers: (state, val)  => { state.sheetDetails.eventNumberOfConcertgoers = val },    
    setSheetDetailsEventNumberOfMusicians: (state, value)   => { state.sheetDetails.eventNumberOfMusicians = value },    
    // SETLIST autocompletes
    setSheetEventVenueOptions: (state, items)               => { state.sheetEventVenueOptions = items },
    setSheetEventOrganizerOptions: (state, items)           => { state.sheetEventOrganizerOptions = items },
    setSheetEventBandleaderOptions: (state, items)          => { state.sheetEventBandleaderOptions = items },
    setSheetEventPerformerOptions: (state, items)           => { state.sheetEventPerformerOptions = items },
    // Venue Dialog
    setSelectedVenueForSheets: (state, items)               => { state.selectedVenueForSheets = items },
    setVenueForSheetsSearch: (state, search)                => { state.venueForSheetsSearch = search },
    setShowConnectVenueToSheetDialog: (state, show)         => { state.showConnectVenueToSheetDialog = show },
    setTotalListedConnectVenueToSheetDialog: (state, value) => { state.totalListedConnectVenueToSheetDialog = value },
    setTotalRecordsConnectVenueToSheetDialog: (state, value)=> { state.totalRecordsConnectVenueToSheetDialog = value },

    // Works Panel
    // setSheetsActivePanels: (state, panels ) => { state.sheetsActivePanels = panels },
    setDefaultSheetsWorks: (state)                          => { state.defaultSheetsWorks = DEFAULT_WORK },
    setSheetsWorks: (state, works)                          => { state.sheetsWorks = works },
    setSheetWorkSearch: (state, input)                      => { state.sheetWorkSearch = input },
    setSelectedSheetWork: (state, works)                    => { state.selectedSheetWork = works },
    setTotalSheetWorkListed: (state, listed)                => { state.totalSheetWorkListed = listed },
    setTotalSheetWorkRecords: (state, records)              => { state.totalSheetWorkRecords = records },
    setSheetWorksAvTypesOptions: (state, options)           => { state.sheetWorksAvTypesOptions = options },
    setSheetWorksCharacteristicOptions: (state, options)    => { state.sheetWorksCharacteristicOptions = options },
    // Editing Dialog
    setSheetsWorksEditingDialogDetails: (state, details)    => { state.sheetsWorksEditingDialogDetails = details },
    setSelectedSheetsWorks: (state, selected)               => { state.selectedSheetsWorks = selected },
    setSheetsWorksDetailsWorkAvType: (state, type)          => { state.sheetsWorksEditingDialogDetails.workAvType = type },
    setSheetsWorksDetailsWorkCharacteristicType: (state, t) => { state.sheetsWorksEditingDialogDetails.workCharacteristicType = t },
    setSheetsWorksDetailsWorkSheetSeconds: (state, seconds) => { state.sheetsWorksEditingDialogDetails.workSheetSeconds = seconds },
    setSheetsWorksDetailsWorkSetlistSeconds: (state, secs)  => { state.sheetsWorksEditingDialogDetails.workSetlistSeconds = secs },
    setSheetsWorksDetailsWorkSetlistType: (state, type)     => { state.sheetsWorksEditingDialogDetails.workSetlistType = type },
    setSheetsWorksDetailsBigRight: (state, right)           => { state.sheetsWorksEditingDialogDetails.bigRight = right },
    // Add Dialog
    setShowConnectWorksToSheetDialog: (state, show)         => { state.showConnectWorksToSheetDialog = show },
    setSheetWorkInterpretOptions: (state, options)          => { state.sheetWorkInterpretOptions = options },
    setSheetWorkDialogDetails: (state, details)             => { state.sheetWorkDialogDetails = details },
    setSheetWorkDetailsInterpret: (state, interpret)        => { state.sheetWorkDialogDetails.interpret = interpret },
    setSheetWorkDetailsWorkTitle: (state, title)            => { state.sheetWorkDialogDetails.title = title },
    setSheetWorkDetailsDuration: (state, value)            => { state.sheetWorkDialogDetails.duration = value },
    setSheetWorkDetailsTags: (state, value)            => { state.sheetWorkDialogDetails.tags = value },

    // PDF
    setSheetsPdf: (state, details)                          => { state.sheetsPdf = details },
    setSheetsPdfFileId: (state, id)                         => { state.sheetsPdf.fileId = id },
    setSheetsPdfPath: (state, path)                         => { state.sheetsPdf.path = path },
    setShowUploadPDFDialog: (state, show)                   => { state.showUploadPDFDialog = show },
    setUploadPDFDialogText: (state, text)                   => { state.uploadPDFDialogText = text },
    setUploadedPDFFileId: (state, id) => { state.uploadedPDFFileId = id },
}

const actions = {
// FETCH SHEETS LIST
    async fetchSheets({ commit, getters }) {
        commit('setIsLoading', true)

        // check for set filters
        let filterObj = {
            'search'    : getters.getSheetsSearch,
            'sheetType' : getters.getSelectedSheetsTypeFilter,
            'year'      :getters.getSelectedSheetsYearsFilter
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setSheets', [])
        } else {
            commit('setSheets', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

// FETCH DETAILS
    async fetchSheetsDetails({ commit, dispatch, getters }, alvId) {
        let values
        let currentPage = router.currentRoute.name
        
        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewSheet)) 
            values = defaultValues
        }
        else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else values = response
        }

        // Convert regions from backend array format to frontend numeric format
        if (values.regions && Array.isArray(values.regions) && values.regions.length > 0 && values.regions[0].value) {
            values.regions = values.regions[0].value
        }

        // Kram, damit die Auswahl angezeigt werden kann... Cache-Problem unserer Autocompletes? => Lisa
        // Lisa: KEIN Problem vom Cache, das ist einfach wie die Autocomplete Dropdowns von vuetify funktionieren. 
        // Diese können nur etwas Auswählen, was in den "Options" im Dropdown auch existiert. Und das tun sie nicht wenn man die Edit Seite neu öffnet. 
        if(values.eventVenue !== null) commit('setSheetEventVenueOptions', [values.eventVenue])
        if(values.eventOrganizer !== null) commit('setSheetEventOrganizerOptions', [values.eventOrganizer])
        if(values.eventBandleader !== null) commit('setSheetEventBandleaderOptions', [values.eventBandleader])
        if(values.eventPerformer !== null) commit('setSheetEventPerformerOptions', [values.eventPerformer])

        commit('setSheetsDetails', values)
        if(alvId !== 'new') dispatch('fetchSheetsPdf')
        if(alvId !== 'new') dispatch('fetchSheetsWorks')
        else commit('setSheetsWorks', [])
        if(currentPage.substr(currentPage.length - 4) === 'Edit') {
            dispatch('fetchSheetDropdownValues')
        }
        commit('setIsLoading', false)
    },

    // EVENT VENUE (autocomplete)
    async fetchAutocompleteSheetEventVenue({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setSheetEventVenueOptions', response.list)
    },

    async fetchAutocompleteSheetEventOrganizer({ commit }, input) {
        let response = await api.getAutocompleteSearch('az', input,'azType=persons,groups')
        commit('setSheetEventOrganizerOptions', response.list)
    },

    async fetchAutocompleteSheetEventBandleader({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setSheetEventBandleaderOptions', response.list)
    },

    async fetchAutocompleteSheetEventPerformer({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setSheetEventPerformerOptions', response.list)
    },

    // EVENT VENUE connect
    async searchVenueForSheets({ getters, commit }) {
        let params = 'search=' + getters.getVenueForSheetsSearch
        let response = await api.getListData("az/live", "1", params)

        commit('setTotalListedConnectVenueToSheetDialog', response.filteredRecords)
        commit('setTotalRecordsConnectVenueToSheetDialog', response.totalRecords)

        return response.list
    },
    // DROPDOWNS
    async fetchSheetDropdownValues({ commit, getters }) {
        let alvId = getters.getSheetDetailsAlvId
        // Version Types
        let versionTypesResponse = await api.getSpecificDropdownValues(DIR, alvId, 'versionTypes')
        commit('setSheetVersionTypeOptions', versionTypesResponse)

        let carrierTypesResponse = await api.getSpecificDropdownValues(DIR, alvId, 'releaseTypes')
        commit('setSheetCarrierTypeOptions', carrierTypesResponse)
    },

    // WORKS Panel
    async fetchSheetsWorks({ commit, getters }) {
        let worksFromDB = getters.getSheetsDetails.works

        if(worksFromDB === undefined || worksFromDB === null) return []
        else {
            if(worksFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
            commit('setSheetsWorks', worksFromDB)
        }

        commit('setIsLoading', false)
    },

    // Search + Add works to Sheet
    async fetchAutocompleteSheetWorkInterpret({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setSheetWorkInterpretOptions', response.list)
    },
    async searchSheetWork({ getters }) {
        
        let params = "search=" + getters.getSheetWorkSearch 
        let response = await api.getFilteredResults("publishing/works", params)
        let list = response.list
        list.forEach(element => {
            element['alvInternalDisable'] = false
        });
        return list
    },
    async addWorksToSheet({ getters, commit, dispatch }, selectedItems) {
        let works = getters.getSheetsWorks

        let startWorksAmount = works.length
        for(let i = 0; i < selectedItems.length; i++) {
            works.push(selectedItems[i])
        }
        let newWorksAmount = works.length
        if(newWorksAmount > startWorksAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERAL_SNACKBAR_ADDED_SUCCESSFULLY') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON')
            })
        }
    },

    // Delete 1 work from a sheet in sheet edit form in the work panel
    async deleteSelectedSheetWork({ getters, commit }) {
        let indexOfSelectedWork = getters.getSelectedSheetWork
        let connectedWorks = getters.getSheetsWorks

        // By counting the entries for and after deleting we can decide if it worked to delete and to know which snackbar to show
        let startWorksAmount = getters.getSheetsWorks.length
        Vue.delete(connectedWorks, indexOfSelectedWork) // delete the work by the index of the whole works list
        let newWorksAmount = getters.getSheetsWorks.length

        if(startWorksAmount > newWorksAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_PUBLISHING_SHEETS_SNACKBAR_DELETE_WORKS_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_PUBLISHING_SHEETS_SNACKBAR_DELETE_WORKS_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedSheetWork', []) // set selected works back to default value
        if(newWorksAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') // if the panel now contains no entries, set the message "No records found"
    },

    // fetch PDF Panel
    async fetchSheetsPdf({ commit, getters }) {
        commit('setIsLoading', true)
        let sheetAlvId = getters.getSheetDetailsAlvId

        let response = await api.getDetailsById(DIR, sheetAlvId, '/pdf' )

        if(response !== undefined) { 
            commit('setSheetsPdf', response.response)   
        } else {
            commit('setSheetsPdf', DEFAULT_PDF)
        }
        commit('setIsLoading', false)
    },

    async deleteSheetPdf({ getters, commit, dispatch }) {
        let sheetAlvId = getters.getSheetDetailsAlvId

        let response = await api.deleteFile(DIR + '/' + sheetAlvId, '?deletePdf')

        if(response.error === -1) {
            dispatch('fetchSheetsPdf')
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_PUBLISHING_SHEETS_SNACKBAR_PDF_DELETED')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_PUBLISHING_SHEETS_SNACKBAR_PDF_NOT_DELETED'),
            })
        }
    },

    // SAVE
    async saveSheetsForm({ commit, getters, dispatch }) {
        let alvId = getters.getSheetDetailsAlvId
        let metaData = getters.getSheetsDetails
        
        // Convert regions: extract value from dropdown object if needed
        if (metaData.regions && typeof metaData.regions === 'object' && metaData.regions.value) {
            metaData.regions = metaData.regions.value
        }
        
        if(getters.getUploadedPDFFileId !== null) metaData['fileId'] = getters.getUploadedPDFFileId
        if(metaData['eventVenue'] !== null) metaData['eventVenue'] = getters.getSheetDetailsEventVenue
        if(metaData['eventVenue'] !== null) metaData['eventVenueId'] = getters.getSheetDetailsEventVenue.id
        if(metaData['eventOrganizer'] !== null) metaData['eventOrganizer'] = getters.getSheetDetailsEventOrganizer
        if(metaData['eventOrganizer'] !== null) metaData['eventOrganizerId'] = getters.getSheetDetailsEventOrganizer.id
        let isNew = router.currentRoute.params.alvId == "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_PUBLISHING_SHEETS_SNACKBAR_SHEET_NOT_SAVED')
            })
        } else {
            await dispatch('fetchSheetsDetails', response.response.alvId)

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_PUBLISHING_SHEETS_SNACKBAR_SHEET_SAVED')
            })

            if(isNew) {
                await dispatch('fetchSheetsDetails', response.response.alvId)
                router.push( { name: 'SheetsEdit', params: { alvId: response.response.alvId }} )
            }
            commit('setUploadedPDFFileId', null)
        }        
    },

// ACTIONS Switch
    async doSheetsAction({ commit, dispatch }) {
        if(state.selectedSheets.length > 0) {
            switch(state.selectedSheetsAction) {
                case 'exportSheets': 
                    if(state.selectedSheets.length === 1 ) {
                        commit('setShowExportSheetsDialog',true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                break
                case 'avReport': 
                    if(state.selectedSheets.length > 0 ) {
                        dispatch('createAvReport')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'avGemaJson': 
                    if(state.selectedSheets.length === 1 ) {
                        dispatch('createAvGemaJson', 'generateReport')
                        commit('setShowGemaAvRegistrationDialog', true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                break
                case 'copy':
                    if(state.selectedSheets.length === 1) {
                        dispatch('copySheet')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'replaceTags': 
                    if(state.selectedSheets.length > 0) {
                        commit('setShowManageTagsDialog', true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'move':
                    if(state.selectedSheets.length > 0) {
                        commit('setShowMoveContractsDialog',true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                        commit('setShowSelectionRequiredDialog', true)	
                    }
                    break
                case 'delete':
                    commit('setShowDeletionDialog', true)
                    break
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)
        }
    },

// Action: Create AV-REPORT
    async createAvReport({ getters, commit }) {
        let metaData = getters.getSelectedSheets
        let queryParams = { "action": "createAvReport" }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response === 1 || response == undefined || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })            
        } else {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }    
    },
    // Action: Create AV-GEMA JSON
    async createAvGemaJson({ getters, commit }, action) {
        commit('setGemaAvRegistrationDialogAllowSend', false)
        commit('setIsLoading', true)
        let metaData = {
            'sheetId': getters.getSelectedSheets[0],
            'action': action
        }
        let queryParams = { "action": "createAvGemaJson" }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        
        if(action === 'generateReport'){
            if(response === 1 || response == undefined || response.error === 1) {
                commit('setGemaAvRegistrationDialogText', response.response.errorMsg)
                commit('setGemaAvRegistrationDialogReportLink', response.response.url)
            }else{
                commit('setGemaAvRegistrationDialogText', response.response.errorMsg)
                commit('setGemaAvRegistrationDialogAllowSend', true)
                commit('setGemaAvRegistrationDialogReportLink', response.response.url)

                if(response.response.processInstanceId){
                    commit('setGemaAvRegistrationDialogText', i18n.t('lang_PUBLISHING_SHEETS_AV_REGISTRATION_DIALOG_GEMA_SUCCESSFUL_REPORT') + response.response.processInstanceId)
                    commit('setGemaAvRegistrationDialogAllowSend', false)
                }
                
            }


        }

        if(action === 'sendJson'){
            if(response === 1 || response == undefined || response.error === 1) {
                commit('setGemaAvRegistrationDialogText', response.response.errorMsg)
                if(response.response.url != null || response.response.url != undefined){
                    commit('setGemaAvRegistrationDialogReportLink', response.response.url)
                }          
            } else {
                commit('setGemaAvRegistrationDialogText', i18n.t('lang_PUBLISHING_SHEETS_AV_REGISTRATION_DIALOG_GEMA_SUCCESSFUL_REPORT') + response.response.processInstanceId)
                commit('setGemaAvRegistrationDialogAllowSend', false)
                commit('setGemaAvRegistrationDialogReportLink', response.response.url)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL')
                })
            } 
        }

        commit('setIsLoading', false)
   
    },
    async exportSelectedSheets({ getters, commit }) {
        let metaData = {
            "alvIds":getters.getSelectedSheets
        }
        let queryParams = { 
            "action": "export",
            "type": getters.getExportSheetsDetailsType
        }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response === 1 || response == undefined || response.error === 1) {
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })
            commit('setShowExportSheetsDialog', false)
            commit('setExportSheetsDetailsType',[])          
        } else {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
            commit('setShowExportSheetsDialog', false)
            commit('setExportSheetsDetailsType',[]) 
        }    
    },
    //Action: Copy

    async copySheet ({getters, commit, dispatch}){
        let queryParams = { "action": "copy" }
        let metaData = { "alvIds": getters.getSelectedSheets }

        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            router.push( { name: 'SheetsEdit', params: { alvId: response.response.alvId }} )
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    //Action : MOVE
    async moveSelectedSheets({ getters, commit, dispatch  }) {

        let metaData = { "alvIds" : getters.getSelectedSheets,
        
                        "company" : getters.getSheetsDetailsSelectedCompany }
        let queryParams = { "action": 'move'}
        const response = await api.triggerAction(DIR,metaData,queryParams)


        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_MOVED')
            })
        }
        
        commit('setSelectedSheets', [])
        commit("setIsAllSelectedSheets",false)
        commit('setSelectedSheetsAction', [])
        dispatch('fetchSheets')
    },

    // Action: DELETE
    async deleteSelectedSheets({ commit, getters, dispatch }) {  
        let selectedSheets = getters.getSelectedSheets
        let sheets = getters.getSheets

        const response = await api.deleteEntries(DIR, selectedSheets)

        if(response.error === -1) {        
            for(let i = 0; i < selectedSheets.length; i++) {
                let index = sheets.findIndex(release => release.alvId == selectedSheets[i])
                Vue.delete(sheets, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedSheets', [])
            commit('setSelectedSheetsAction', [])
            dispatch('fetchSheets')
        }
    },   
}

export default { state, getters, actions, mutations }